import { useState } from 'react';
// import { useCallback, useEffect, useState } from 'react';
import { useForm } from './useForm';
import { useNavigate } from 'react-router-dom';
import { Cfop } from '../routes/RoutesNames';
//import CfopController from '../controllers/CfopController';
//import { ClienteDetalheSchema } from '../schemas/ClienteDetalheSchema';
// import { CfopRequest } from '../controllers/Types';
//import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
//import Cfop from '../pages/Dashboard/Cfop/Pesquisar/CfopPesquisar';

const useCfop = () => {
    const navigation = useNavigate();
    //   const [cfop, setCfop] = useState<CfopRequest | any>({});
    const [single, setSingle] = useState<any>(null);
    const { userId } = useSelector((state) => state.Authentication);
    //const ref = useRef<HTMLButtonElement>(null);


    const backActions = () => {
        navigation(Cfop);
    };

    const initialValues = {
        UsuId: userId,
        Cfop_Id: single?.cfop_id || '',
        Cfop_Descricao: single?.cfop_descricao || '',
        Cfop_Tipo: single?.cfop_tipo || '',
        Cfop_Venda: single?.cfop_venda || '',
    };
    
    const onSubmit = async (data: any) => {
        console.log('onSubmit');
        console.log(data);
      };

    const form = useForm({
        onSubmit: onSubmit,
        initialValues:initialValues ,
        //validationSchema: ClienteDetalheSchema,
    });



    //   const getClienteById = useCallback(async () => {
    //     if (!cfop_id) return;
    //     try {
    //       setLoading(true);
    //       const Response = await CfopController.ListarUnico(cfop_id);
    //       //console.log(Response);
    //       if (Response.Data) {
    //         //console.log(Response.Data.cli_datanascimento);
    //         setCliente({
    //           Codigo: Response.Data.cfop_id,
    //           Descricao: Response.Data.cfop_descricao,
    //           Tipo: Response.Data.cfop_tipo,
    //           Venda: Response.Data.cfop_venda,

    //         });     
    //       }

    //     } catch (error) {
    //       console.error('Error fetching user:', error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   }, [cfop_id]);

    //   useEffect(() => {
    //     getClienteById();
    //   }, [getClienteById]);


    return {
        ...form,
        backActions,
        initialValues,      
    };
};

export default useCfop;
